import { axios } from '@/plugins/axios';
import AltoleapAccounts from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';

import { IStore } from '../store.types';

const tokenService = new AltoleapAccounts.TokenService();

function createRequestInterceptor(store: IStore) {
  axios.interceptors.request.use(function(config) {
    if (
      config.url?.match('token/refresh') == undefined &&
      localStorage.getItem('user') != null
    ) {
      const tokenData = tokenService.decodeToken(
        tokenService.getToken! as string
      ) as Record<string, any>;

      const needsRefresh = tokenService.needsRefresh(tokenData.exp);
      const refreshToken = tokenService.getRefreshToken;

      if (needsRefresh && refreshToken) {
        const authService = new AltoleapAccounts.AuthService(axios);

        authService.refreshToken(refreshToken);
      }
    }
    return config;
  });
}

const plugin = (store: IStore) => {
  createRequestInterceptor(store);
};

export default plugin;
